import { registerMutation, useMutation } from 'data-fetching-client';
import UserObjectsApi from '../api/UserObjectsApi';
const updateUserObjectPropertiesQuery = registerMutation({
  fieldName: 'updateUserObjectProperties',
  args: ['userId', 'properties', 'isViewingSelf'],
  fetcher: ({
    userId,
    properties,
    isViewingSelf
  }) => UserObjectsApi.updateUserProperties(userId, properties, isViewingSelf)
});
export const useUpdateUserObjectProperties = () => {
  const [updateUserObjectProperties, result] = useMutation(updateUserObjectPropertiesQuery);
  if (result.error) {
    console.error(result.error);
  }
  return {
    updateUserObjectProperties,
    result
  };
};